import React, { useEffect, useReducer } from 'react'

import cn from 'classnames'
import ButtonBlue from 'components/ui/button/_color/_blue'
import { useAppSelector } from 'store/hooks'
import { LoginStatuses, selectedAuthStatus } from 'store/reducers/users'
import { useTranslation } from 'utils/use-translation'
import { useRouter } from 'next/router'

import DownloadWhiteIcon from 'images/dowload.png'

import Link from 'next/link'

import Image from 'next/image'

import { ReactSVG } from 'react-svg'

import * as ga from 'libs/ga'

import LocaleButton from '../locale-button'

import Logo from '../../icons/logo.png'
import ChevronIcon from '../../icons/chevron-right.svg'
import PlaystoreIcon from '../../icons/playstore.png'
import AndroidIcon from '../../icons/android.svg'
import DownloadIcon from '../../icons/download-icon.png'
import LogoWhiteIcon from '../../icons/logo-white.png'

import { MenuToggleButton } from '../..'

import styles from '../../styles.module.scss'
import { getDownloadLink } from '../../../../../store/fetchers/utils'

const MobileMenu = ({ isOpen, onClose, items, type = 'primary', isLocalePopupOpen, setIsLocalePopupOpen }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const authStatus = useAppSelector(selectedAuthStatus)

  const [expandedState, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'TOGGLE':
        return {
          ...state,
          [action.id]: !state[action.id],
        }
      case 'CLOSE_ALL':
        return {
          0: true,
        }
      default:
        return state
    }
  }, {})

  const handleLinkClick = () => {
    onClose()
  }

  const toggleItem = (id: number) => {
    dispatch({ type: 'TOGGLE', id })
  }

  useEffect(() => {
    if (!isOpen) {
      dispatch({ type: 'CLOSE_ALL' })
    }
  }, [isOpen])

  const downloadApp = async () => {
    const res = await getDownloadLink()

    if (!res) {
      return
    }
    window.location.assign(res.url)
  }

  return (
    <div
      className={cn(styles['mobile-menu'], {
        [styles['mobile-menu-open']]: isOpen,
        [styles.secondary]: type !== 'primary',
      })}
    >
      <div className={cn(styles['mobile-menu__content'])}>
        <div className={styles['mobile-menu__content-wrapper']}>
          <div className={styles['header-wrapper']}>
            <div className={styles['logo-wrapper']}>
              <div className={styles.logo} onClick={onClose}>
                <Link prefetch={false} href={router.pathname.includes('earn') ? '/earn' : '/'}>
                  <Image src={type === 'primary' ? Logo : LogoWhiteIcon} width={121} height={24} />
                </Link>
              </div>
            </div>

            <MenuToggleButton isOpen={isOpen} onClick={onClose} type={type} />
          </div>

          <nav className={styles.nav}>
            <ul className={styles['nav-list']}>
              {items?.map((it, id) => (
                <li
                  className={cn(styles['nav-list__item'], {
                    [styles['nav-list__item--expanded']]: expandedState[id],
                  })}
                  onClick={() => {
                    if (it?.items?.length) return

                    onClose()
                    router.push(it.link)
                  }}
                  key={id}
                >
                  <div
                    className={styles['nav-item-header']}
                    onClick={() => (it?.items?.length ? toggleItem(id) : handleLinkClick())}
                  >
                    <span className={cn(styles['nav-item-text'])}>{it.item}</span>

                    {it?.items?.length > 0 && (
                      <ReactSVG className={styles['nav-item-chevron']} src={ChevronIcon} width={20} height={20} />
                    )}
                  </div>

                  {it?.items?.length > 0 && (
                    <ul className={cn(styles['nav-item-items'])}>
                      {it?.items?.map((it, id) => (
                        <li
                          key={id}
                          onClick={() => {
                            onClose()
                            router.push(it.link)
                          }}
                        >
                          <ReactSVG
                            src={it.icon}
                            className={!['/', '/wallet', '/earn'].includes(it.link) && styles.itemIcon}
                            width={24}
                            height={24}
                          />
                          <span
                            className={cn({
                              [styles['api-title']]: it.link === '/partners',
                            })}
                          >
                            {it.title}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.locale}>
            <LocaleButton isOpen={isLocalePopupOpen} setIsOpen={setIsLocalePopupOpen} />
          </div>

          <a
            href="https://play.google.com/store/apps/details?id=com.coinrabbit"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ga.event({
                action: 'click_download_app_button',
              })
            }}
            className={cn(styles.btn__download, styles.btn__download_app)}
          >
            <Image src={PlaystoreIcon} width={24} height={24} />
            <span>{t('download_app')}</span>
            <Image src={type !== 'primary' ? DownloadWhiteIcon : DownloadIcon} width={20} height={20} />
          </a>

          <button onClick={downloadApp} className={cn(styles.btn__download)}>
            <Image src={AndroidIcon} width={24} height={24} />
            <span>{t('install_apk')}</span>
            <Image src={type !== 'primary' ? DownloadWhiteIcon : DownloadIcon} width={20} height={20} />
          </button>

          <div className={styles.buttons}>
            {(authStatus === LoginStatuses.LOGOUT || authStatus === LoginStatuses.INIT) && (
              <ButtonBlue
                className={cn(styles.button, {
                  [styles.tretiary]: type === 'tretiary',
                })}
                onClick={() => {
                  onClose()
                  router.push('/user/sign-in')
                }}
              >
                {t('sign_in')}
              </ButtonBlue>
            )}

            {authStatus === LoginStatuses.LOGIN && (
              <>
                <ButtonBlue
                  className={cn(styles.button, {
                    [styles.tretiary]: type === 'tretiary',
                  })}
                  onClick={() => {
                    onClose()
                    router.push('/account/dashboard')
                  }}
                >
                  {t('my_wallet')}
                </ButtonBlue>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileMenu
